import React from "react";
import { Field } from "formik";
import { makeStyles, TextField } from "@material-ui/core";
import formFieldStyles from "./formFieldStyle";

const useStyles = makeStyles((theme) => formFieldStyles(theme));

const FormField = ({ name, ...rest }) => {
  const classes = useStyles();

  return (
    <Field name={name}>{({ field, form }) => (
      <TextField
        {...rest}
        error={!!form.errors[name]}
        helperText={form.errors[name] || " "}
        className={classes.baseInput}
        id={name}
        value={field.value}
        onChange={({ target }) => {
          let value = target.value
          if (rest.type === "number" && !isNaN(target.valueAsNumber)) value = target.valueAsNumber
          form.setFieldValue(name, value)
        }}
      />
    )}</Field>
  );
}

export default FormField
